import React from "react";
import PropTypes from "prop-types";
import useStyles from "./styles";

import { Grid, AppBar, Tabs, Tab, Box } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Grid
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box style={{ overflow: "hidden" }}>
					<Grid>{children}</Grid>
				</Box>
			)}
		</Grid>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`
	};
}

const HorizontalMenu = props => {
	const classes = useStyles();
	const theme = useTheme();
	const {
		listMenu,
		heightBody,
		background,
		handleHorizontalMenu,
		value,
		handleChange
	} = props;

	return (
		<Grid className={classes.root}>
			<AppBar position="static" classes={{ root: classes.rootAppBar }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="simple tabs example"
					variant="fullWidth"
					TabIndicatorProps={{
						style: {
							backgroundColor: theme.palette.primary.main
						}
					}}
					classes={{ root: classes.rootTabs }}
				>
					{listMenu.map((item, index) => (
						<Tab
							key={index}
							label={item.label}
							disabled={item.disabled && item.disabled}
							onClick={() => handleHorizontalMenu(item.code)}
							{...a11yProps(index)}
							classes={{
								root: classes.rootTab,
								selected: classes.selected
							}}
						/>
					))}
				</Tabs>
			</AppBar>
			{listMenu.map((item, index) => (
				<TabPanel
					key={index}
					value={value}
					index={index}
					style={{
						height: heightBody,
						overflowY: "scroll",
						background: background
					}}
				>
					{item.component}
				</TabPanel>
			))}
		</Grid>
	);
};

export default HorizontalMenu;
